import { render, staticRenderFns } from "./MeiliSearchList.vue?vue&type=template&id=bfb401a4&"
import script from "./MeiliSearchList.vue?vue&type=script&lang=js&"
export * from "./MeiliSearchList.vue?vue&type=script&lang=js&"
import style0 from "./MeiliSearchList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports